import * as React from "react";

// Status Badge Component
const StatusBadge = ({ status, size="sm", variant = "default" }) => {
  // const variants = {
  //   "under-review": "bg-[#FFF3CD] text-[#AD6800] border-[#FFEAA7]",
  //   submitted: "bg-[#E6F3E7] text-[#008A10] border-[#C3E6CB]",
  //   funded: "bg-[#008A10] text-[#FFF] border-[#C3E6CB]",
  //   rejected: "bg-[#DA1E28] text-[#FFF] border-[#F5C6CB]",
  //   draft: "bg-[#F0F0F0] text-[#262626] border-[#D6D8DB]",
  //   withdrawn: "bg-[#FDEBEC] text-[#DA1E28] border-[#FFEAA7]",
  //   "on-time": "bg-[#D4EDDA] text-[#155724] border-[#C3E6CB]",
  //   delayed: "bg-[#F8D7DA] text-[#721C24] border-[#F5C6CB]",
  //   default: "bg-[#E2E3E5] text-[#383D41] border-[#D6D8DB]",
  // };

  const variants = {
    "under-review": "bg-system-warning-1 text-system-warning-2 border-system-warning-2",
    submitted: "bg-system-positive-1 text-system-positive-2 border-system-positive-2",
    funded: "bg-system-positive-2 text-neutral-1 border-neutral-1",
    rejected: "bg-system-negative-2 text-neutral-1 border-neutral-1",
    draft: "bg-neutral-4 text-neutral-10 border-neutral-10",
    withdrawn: "bg-system-negative-1 text-system-negative-2 border-system-negative-2",
    "on-time": "bg-system-positive-1 text-system-positive-2 border-system-positive-2",
    delayed: "bg-system-negative-1 text-system-negative-2 border-system-negative-2",
    default: "bg-neutral-3 text-neutral-8 border-neutral-8",
  };
  const sizes ={
    sm:"px-2.5 py-1 text-xs rounded",
    md:"px-3 py-1.5 text-sm rounded-md",
    lg:"px-4 py-2 text-md rounded-lg",
    default:"px-2.5 py-1 text-xs",
  }

  return (
    <span
      className={`
      inline-flex items-center rounded font-medium border-0
      ${variants[variant] || variants.default}
      ${sizes[size] || variants.sizes}
    
      `}
    >
      {status}
    </span>
  );
};

const ActionButton = ({ onClick, category, icon: Icon }) => {
  // Determine button text and style based on category
  const getButtonConfig = (category) => {
    switch (category) {
      case "requiresAttention":
        return { text: "Add Details", variant: "primary" };
      case "draft":
        return { text: "Continue", variant: "secondary" };
      default:
        return { text: "View Loan", variant: "secondary" };
    }
  };

  const config = getButtonConfig(category);
  const buttonText = config.text;
  const buttonVariant = config.variant;

  const variants = {
    primary: "bg-primary-3 hover:bg-primary-2 text-neutral-1",
    secondary:
      "bg-primary-7 hover:bg-primary-5 text-neutral-10 border border-neutral-5",
  };

  return (
    <button
      onClick={onClick}
      className={`
        inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium
        transition-colors focus:outline-none focus:ring-2 focus:ring-primary-3 focus:ring-offset-2
        ${variants[buttonVariant]}
      `}
    >
      {buttonText}
      {Icon && <Icon size={16} />}
    </button>
  );
};

export { StatusBadge, ActionButton };
